import { createTheme } from "@mui/material/styles";

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#2563EB", // Request Demo button / primary blue
    },
    secondary: {
      main: "#FF2E63", // accent magenta
    },
    background: {
      default: "#FFFFFF",
      paper: "#F8FAFC",
    },
    text: {
      primary: "#0C1636", // dark text on light background
      secondary: "#475569", // muted gray text
    },
    warning: {
      main: "#FFC300", // yellow accent
    },
    info: {
      main: "#00C4FF", // cyan accent
    },
    success: {
      main: "#22C55E",
    },
    error: {
      main: "#DC2626",
    },
  },
  typography: {
    fontFamily: `"Mulish", sans-serif`,
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    body1: { fontSize: 16 },
    body2: { fontSize: 14 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: {
    borderRadius: 8,
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#2563EB",
    },
    secondary: {
      main: "#FF2E63",
    },
    background: {
      default: "#0C1636", // dark navy background
      paper: "#0C1636",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#A0AEC0",
    },
    warning: {
      main: "#FFC300",
    },
    info: {
      main: "#00C4FF",
    },
    success: {
      main: "#22C55E",
    },
    error: {
      main: "#DC2626",
    },
  },
  typography: {
    fontFamily: `"Mulish", sans-serif`,
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    body1: { fontSize: 16 },
    body2: { fontSize: 14 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: {
    borderRadius: 8,
  },
});
